import React, { useEffect, useMemo, useRef, useState } from "react";
import styles from '../styles/venueFilter.module.scss'
import SpriteContainer from "@/wmCompoments/spriteContainer";
import Icon from "@/wmCompoments/Icon";
import SelectPlus from "@/wmCompoments/select";
import { useTranslation } from "react-i18next";

export interface VenueFilterProps {
  value: {
    venueId: number
  }
  venueOptions: any[]
  onChange: (venueId: any) => void
}

const VenueFilter = ({ value, onChange, venueOptions}: VenueFilterProps) => {
  const { t } = useTranslation('record')
  // 下拉框位置定位
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [container, setContainer] = useState<HTMLElement | null>(null);
  // 组件挂载后再设置 portal 容器
  useEffect(() => {
      if (containerRef.current) {
          setContainer(containerRef.current);
      }
  }, []);
  // 从父组件传入的venueId映射到对应的value（用于显示，默认第一项全部）
  const selectedOption = venueOptions.find(v => v.value === value.venueId);
  const selectedValue = selectedOption?.value;

  return(
    <div className={styles.venueFilter}>
      <div className={styles.venue_title}>{t('selectVenue')}</div>
      <div ref={containerRef} className={styles.container}>
        <SelectPlus
          options={venueOptions}
          value={selectedValue}
          onChange={(v, o) => {
            onChange(o.value); 
          }}
          optionRender={(opt, selected) => (
            <div className={styles.optionRender}>
              <span>{opt.label}</span>
              {selected && <SpriteContainer name="icon_checked" />}
            </div>
          )}
          labelRender={(opt) => {
            return (
              <div className={styles.labelRender}>
                <span>{opt?.label}</span>
                <Icon name={'icon-general-arrow-line-right'} className={styles.icon} />
              </div>
            )
          }}
          className={styles.select}
        />
      </div>
    </div>
  )
}

export default VenueFilter